export interface PodcastSearchResult {
  id: number;
  title: string;
  author: string;
  imageUrl: string;
  feedUrl: string;
  description: string;
}

async function fetchWithCorsFallback(url: string): Promise<any> {
  try {
    // Try direct fetch first
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok.');
    return await response.json();
  } catch (error) {
    // If direct fetch fails, try with CORS proxy
    console.log('Direct fetch failed, trying CORS proxy...', error);
    try {
      const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(url)}`;
      const response = await fetch(proxyUrl);
      if (!response.ok) throw new Error('Proxy response was not ok.');
      const data = await response.json();
      return JSON.parse(data.contents);
    } catch (proxyError) {
      console.error('Both direct and proxy fetch failed:', proxyError);
      throw error; // Throw original error
    }
  }
}

export async function searchPodcasts(query: string): Promise<PodcastSearchResult[]> {
  try {
    const apiUrl = `https://itunes.apple.com/search?term=${encodeURIComponent(query)}&entity=podcast&limit=20`;
    const data = await fetchWithCorsFallback(apiUrl);

    if (!data.results || data.results.length === 0) {
      return [];
    }

    return data.results.map((result: any) => ({
      id: result.collectionId,
      title: result.collectionName || result.trackName,
      author: result.artistName,
      imageUrl: result.artworkUrl600 || result.artworkUrl100,
      feedUrl: result.feedUrl,
      description: result.collectionName || '',
    }));
  } catch (error) {
    console.error('Error searching podcasts:', error);
    throw new Error('Failed to search podcasts');
  }
}
